function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99997 10.2174C11.7004 10.2174 13.8913 8.02653 13.8913 5.32612C13.8913 2.62571 11.7004 0.434814 8.99997 0.434814C6.29957 0.434814 4.10867 2.62571 4.10867 5.32612C4.10867 8.02653 6.29957 10.2174 8.99997 10.2174ZM13.3478 11.3044H11.4762C10.7221 11.6508 9.88313 11.8479 8.99997 11.8479C8.11682 11.8479 7.28122 11.6508 6.52375 11.3044H4.65215C2.25065 11.3044 0.304321 13.2507 0.304321 15.6522V16.1957C0.304321 17.0958 1.03462 17.8261 1.93476 17.8261H16.0652C16.9653 17.8261 17.6956 17.0958 17.6956 16.1957V15.6522C17.6956 13.2507 15.7493 11.3044 13.3478 11.3044Z"
});

var SvgUserIcon = function SvgUserIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-icon.a444c9af.svg";
export { ForwardRef as ReactComponent };